// extracted by mini-css-extract-plugin
export var cartContainer = "_j6-4";
export var gray = "_j6-1";
export var itemContainer = "_j6-2";
export var itemDetails = "_j6-3";
export var strong = "_j6-0";